import HttpMethodType from 'HttpMethodType';
import SubSystemType from 'SubSystemType';
import BaseServiceRequest from 'BaseServiceRequest';

class GetTransactionsDataRequest extends BaseServiceRequest {
  constructor(portfolioID, oid,frmdate, todate, getlong, getshort, currcode) {
    super();
    super.addRequestUri("gettransactionnodes");
    super.addRequestParameter("pids", portfolioID);
    super.addRequestParameter("oid", oid);
    super.addRequestParameter("frmdate", frmdate);
    super.addRequestParameter("todate", todate);
    super.addRequestParameter("getlong", getlong);
    super.addRequestParameter("getshort", getshort);
    super.addRequestParameter("currcode", currcode);
  }

  getMethod() {
    return HttpMethodType.GET;
  }

  getSubSystem() {
    return SubSystemType.ACCOUNT_ANALYZER;
  }

  // getMessageName() {
  //   return "TransactionsResponseData";
  // }
}

export default GetTransactionsDataRequest;
